import React, { useState, useEffect } from 'react';
import LinearThinkReviewsListItem from './LinearThinkingReviewsListItem';
import styled from 'styled-components';
import OutlinedButton from 'components/OutlinedButton';
import { toScreen } from 'utils/media-query/responsive.util';

const ListWrapper = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  padding: 0;
  margin: 0;

  ${toScreen(1143)} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  ${toScreen(775)} {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const LoadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ITERMS_PER_PAGE = 6;

const LinearThinkReviewsList = ({ reviews = [] }) => {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);

  function loadMore() {
    setPage(page + 1);
  }

  useEffect(() => {
    if (page > 0) {
      const startIndex = page * ITERMS_PER_PAGE;
      const endIndex = startIndex + ITERMS_PER_PAGE;
      const newItems = reviews.slice(startIndex, endIndex);
      setItems(prevItems => [...prevItems, ...newItems]);
    }
  }, [page, reviews]);

  useEffect(() => {
    setItems(reviews.slice(0, ITERMS_PER_PAGE));
  }, [reviews]);

  return (
    <>
      <ListWrapper>
        {items.map((item, index) => (
          <LinearThinkReviewsListItem
            key={item.node.id}
            {...item}
            index={index}
          />
        ))}
      </ListWrapper>
      {items.length < reviews.length && (
        <LoadMoreWrapper>
          <OutlinedButton onClick={loadMore}>Hiển thị thêm</OutlinedButton>
        </LoadMoreWrapper>
      )}
    </>
  );
};

export default LinearThinkReviewsList;
